import {columnsTableObjReal as columnsTableObjReal_v1,subTitlesTableObjReal as subTitlesTableObjReal_v1} from './columns_OBJREAL';
import {columnsTableObjReal as columnsTableObjReal_v2,subTitlesTableObjReal as subTitlesTableObjReal_v2} from './columns_OBJREAL_v2';
import {columnsTableObjReal as columnsTableObjReal_v3,subTitlesTableObjReal as subTitlesTableObjReal_v3} from './columns_OBJREAL_v3';

export const columnsTableObjReal = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return columnsTableObjReal_v1(año);
        case 2:
            return columnsTableObjReal_v2(año);
        case 3:
            return columnsTableObjReal_v3(año);
        default: 
            return columnsTableObjReal_v1(año);
    }
}

export const subTitlesTableObjReal = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return subTitlesTableObjReal_v1(año);
        case 2:
            return subTitlesTableObjReal_v2(año);
        case 3:
            return subTitlesTableObjReal_v3(año);
        default: 
            return subTitlesTableObjReal_v1(año);
    }
}